import { gmapApi } from 'vue2-google-maps';

export default {
  computed: {
    googleApi: gmapApi,
  },
  methods: {
    async getClientAddress(position) {
      const result = await this.geocodeClientAddress('location', position);

      if (result && result.formatted_address) {
        return Promise.resolve(result);
      }
    },
    async getClientAddressPosition(address) {
      const result = await this.geocodeClientAddress('address', address);

      if (result.geometry && result.geometry.location) {
        const position = {
          lat: result.geometry.location.lat(),
          lng: result.geometry.location.lng(),
        };

        return Promise.resolve(position);
      }
    },
    geocodeClientAddress(requestKey, payload) {
      if (!this.googleApi) {
        return Promise.resolve({});
      }
      const geocoder = new this.googleApi.maps.Geocoder();

      return new Promise((resolve, reject) => {
        geocoder.geocode({ [requestKey]: payload }, (results, status) => {
          if (status === 'OK') {
            if (results[0]) {
              resolve(results[0]);
            } else {
              /* eslint-disable */
              reject('No results found');
            }
          } else {
            window.reportError(`Geocoder error, status: ${status}`, { context: { [requestKey]: payload, results } });

            /* eslint-disable */
            reject('Error getting new position due to: ' + status);
          }
        });
      });
    },
  },
};
